var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav my-0"},[_c('li',{attrs:{"id":"prev-button"}},[_c('button',{attrs:{"type":"button","disabled":_vm.current_page === 0},on:{"click":_vm.prevPage}})]),_c('li',{attrs:{"id":"next-button"}},[_c('button',{attrs:{"type":"button","disabled":_vm.current_page >= _vm.pageCount -1},on:{"click":_vm.nextPage}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }